module.exports = __webpack_public_path__ + "static/demolition-interior-a8e465bce116a4cb8862ca427ace452b.png";